import { Paper, Typography,  Divider, TableContainer, Table, TableHead, TableRow, TableCell,IconButton } from "@mui/material";
import CustomTableBody from "../../utilis/component/CustomTableBody";
import { useNavigate } from "react-router-dom";
import { base } from "../../constants";
import moduleRoutes from "../../routes/moduleRouteList";
import SettingsRouteList from "../routeList";
import EditIcon from "@mui/icons-material/Edit";
import { useQuery } from "react-query";
import { PostOfficeListType } from "./types";
import { getPostOfficeTableData } from "./Service";


function PostOfficeList() {
    const title="Post Office"
    const navigate=useNavigate()

     const handleNavigateClick = (data?:any) => {
            navigate(
                `${base}${moduleRoutes.mainRoute}/${moduleRoutes.settings}/${SettingsRouteList.postOffice}/${SettingsRouteList.addOrEdit}`,
                { state: { data: data || null } }
            );
        };
     const {
            data: tableData,
            isLoading: tableDataLoading,
        } = useQuery(
            [""],
            getPostOfficeTableData,
            {
                refetchOnWindowFocus: false,
            }
        );  

  return (
          <Paper className="m-3 mt-6">
                <div className="flex justify-between p-3">
                    <div className="flex gap-2">
                        <Typography variant="h6" color={"default"}>
                          {title} List
                        </Typography>
                    </div>
                </div>
                <Divider />
                <div className="">
                    
                    <TableContainer className="border">
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    {headings.map((heading) => (
                                        <TableCell key={heading} className="font-bold">
                                            {heading}
                                        </TableCell>
                                    ))}
                                    <TableCell className="font-bold">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <CustomTableBody
                                alert={"No data"}
                                dataLoading={tableDataLoading}
                                isData={Boolean(tableData?.response?.length)}
                                totalSpan={{
                                    row: 4,
                                    col: headings.length+1,
                                }}
                            >
                                {tableData?.response?.map((tableItem:PostOfficeListType, index:number) => (
                                    <TableRow key={`${title}-${index}`}>
                                        <TableCell>{index+1}</TableCell>
                                         <TableCell>{tableItem?.poName}   </TableCell>
                                         <TableCell> {tableItem?.poLink}  </TableCell>
                                        <TableCell>
                                            <div className="flex gap-2">
                                                <IconButton
                                                    color="primary"
                                                    onClick={() => {
                                                        handleNavigateClick(tableItem);
                                                    }}
                                                >
                                                    <EditIcon/>
                                                </IconButton>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </CustomTableBody>
                        </Table>
                    </TableContainer>
                </div>
            </Paper>
  )
}

export default PostOfficeList

const headings=[
    "SL No",
    "Post Office Name",
    "Post Office Link",
]

